import React, { useState } from "react";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import BranchImageCrop from "components/dashboard/Branches/BranchImageCrop/BranchImageCrop";
import { branchImageActions } from "components/dashboard/Branches/BranchImageCrop/enums";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import {
    DEPENDENCY_BRANCH_UPDATE_PERMISSION,
    DEPENDENCY_READ_PERMISSION,
} from "components/dashboard/TrainSAM/Dependency/permissions";
import {
    CAPSULE_UPDATE_PERMISSION,
    KNOWLEDGE_BASE_READ_PERMISSION,
} from "components/dashboard/KnowledgeBase/permissions";
import {
    CONVERSATION_LIBRARY_READ_PERMISSION,
    ISSUE_CONVERSATION_UPDATE_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";
import { baseResources, baseResourceActions } from "routes/enum";
import { apiRoute } from "services";
import ConfirmationModal from "components/dashboard/common/ConfirmationModal/ConfirmationModal";
import "./BranchImageAttachment.scss";

const { AGENTS_INBOX_CONVERSATION_BREAKER, AGENTS_INBOX_SERVICE_SETTING } =
    baseResources;
const { UPDATE, READ } = baseResourceActions;

const { VIEW_IMAGE, ATTACH_IMAGE } = branchImageActions;

const BranchImageAttachment = ({ branch, handleRefresh }) => {
    const { branchMainSentenceImgUrl, branchId } = branch || {};
    const [showModal, toggleModal] = useState(false);
    const [showDeleteModal, toggleDeleteModal] = useState(false);
    const [branchImageAction, setBranchImageAction] = useState();

    const handleToggleModal = () => {
        toggleModal(!showModal);
    };

    const handleOpenDeleteModal = () => {
        handleToggleModal();
        toggleDeleteModal(true);
    };

    const handleBranchAction = () => {
        setBranchImageAction(
            branchMainSentenceImgUrl ? VIEW_IMAGE : ATTACH_IMAGE
        );
    };

    return (
        <>
            <div
                className='branch__image__attached'
                onClick={handleToggleModal}>
                <ReactSVG
                    src={asset.icons.indicator}
                    className='branch__image__attached--icon'
                />
                <ComponentAccessControl
                    baseResources={[
                        ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
                        ...CAPSULE_UPDATE_PERMISSION,
                        `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
                        ...ISSUE_CONVERSATION_UPDATE_PERMISSION,
                        ...DEPENDENCY_READ_PERMISSION,
                        ...KNOWLEDGE_BASE_READ_PERMISSION,
                        `${READ}_${AGENTS_INBOX_SERVICE_SETTING}`,
                        ...CONVERSATION_LIBRARY_READ_PERMISSION,
                    ]}>
                    <span
                        className='branch__image__attached--text'
                        onClick={handleBranchAction}>
                        {branchMainSentenceImgUrl
                            ? `View image`
                            : `Attach an image.`}{" "}
                    </span>
                </ComponentAccessControl>
            </div>

            {showModal && (
                <BranchImageCrop
                    showModal={showModal}
                    toggleModal={handleToggleModal}
                    branchImageAction={branchImageAction}
                    referenceData={branch}
                    handleRefresh={handleRefresh}
                    handleOpenDeleteModal={handleOpenDeleteModal}
                />
            )}

            {showDeleteModal && (
                <ConfirmationModal
                    title='Are you sure you want to Delete this branch image'
                    show={showDeleteModal}
                    closeModal={() => toggleDeleteModal(false)}
                    handleSuccess={() => handleRefresh(branch?.branchId)}
                    url={apiRoute.deleteBranchImage(branchId)}
                    method='delete'
                />
            )}
        </>
    );
};

export default BranchImageAttachment;
